import { Button, Icon } from "@mindlercare/ui-web";
import { styled } from "styled-components";
import { useMindlerApi } from "api/apiv2";
import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";
import { usePatientUserIdFromUrl } from "hooks/usePatientUserIdFromUrl";

export const SelectedPatientButton = () => {
  const { t } = useTranslation();
  const [patientUserId, setPatientUserId] = usePatientUserIdFromUrl();
  const apiv2 = useMindlerApi();
  const { data: patient } = useQuery(
    apiv2.patients.getByUserId.queryOptions(
      {
        patientUserId: Number(patientUserId),
      },
      {
        enabled: !!patientUserId,
      },
    ),
  );

  if (!patientUserId || !patient) return null;

  return (
    <Tooltip title={t("SELECTED_PATIENT_TOOLTIP")} placement="bottom-start">
      <div>
        <PatientButton
          onClick={() => setPatientUserId(null)}
          id="selectedPatientButton"
          data-testid="selectedPatientButton"
          variant="tertiary"
        >
          <span>{`${patient?.firstName} ${patient?.lastName}`}</span>
          <Icon.Close width={20} />
        </PatientButton>
      </div>
    </Tooltip>
  );
};

const PatientButton = styled(Button)`
  height: unset;
  padding: ${(props) => `${props.theme.SPACING.SM} ${props.theme.SPACING.MD}`};
  position: relative;
  background-color: ${(props) => props.theme.COLORS.GRAY_LIGHT};
  font-size: ${(props) => props.theme.FONT.SIZE.SMALL_MEDIUM};
  margin-right: ${(props) => props.theme.SPACING.SM};

  span {
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  & svg {
    width: ${(props) => props.theme.FONT.SIZE.STANDARD};
    height: ${(props) => props.theme.FONT.SIZE.STANDARD};
  }

  overflow: hidden;
`;
